import React, { useEffect } from 'react'
import {
  Card, CardHeader, Row, Col, Badge, CardBody
} from 'reactstrap'
import { Bar } from 'react-chartjs-2'
import colorChats from '../../lib/colorChats'
import { useState } from 'react'
import BarrasHorizontal from './BarrasHorizontal'

var tituloGrafico = ''

const mascaraLabel = (valor)=>{
  if(tituloGrafico === 'Atendimento por Quantidade'){
    return(valor);
  }else{
    return(parseFloat(valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}))
  }
}

const options = {
  legend: {
    display: false,
    position: 'top'
  },
  tooltips: {
    enabled: true,
    callbacks: {
      label: function(tooltipItem, data) {
        
        var label = mascaraLabel(data.datasets[0].data[tooltipItem.index]);
        var dataset = data.datasets[tooltipItem.datasetIndex]
        var total = dataset.data.reduce((total, currentElement) => parseFloat(total) + parseFloat(currentElement))
        var valor = dataset.data[tooltipItem.index]
        var porcentagem = parseFloat((valor/total*100).toFixed(1))
        label += ' ('+porcentagem+'%)'
        return label
      },
      title: function(tooltipItem, data) {
        return data.labels[tooltipItem[0].index]
      },
    }
  },
  scales: {
    yAxes: [
      {
        ticks: {
          display: false,
          min: 0
        },        
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(255,255,255,0.1)"
        }
      }
    ],
    xAxes: [
      {
        barPercentage: 0.8,
        gridLines: {
          drawBorder: true,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent"
        },
        ticks: {
          display: true
        }
      }
    ]
  }
}

const BarrasCard = ({ title, color, dados }) => {
  var data='';

  tituloGrafico = title;

  const [totalGrafico, setTotalGrafico] = useState(0);

  useEffect(()=>{
    let total = 0;
    if(dados.valores){
      dados.valores.forEach(valor=>{
        total += Number(valor)
      })

      if(title === "Atendimento por Quantidade"){
        total = 'Total: ' + total;
      }else{
        //total = 'R$ ' + total.toFixed(2);
        total = parseFloat(total).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
      }

      setTotalGrafico(total);
    }
  },[]) // eslint-disable-line react-hooks/exhaustive-deps

  if (typeof dados != "undefined") {

    data = {
      labels:dados.lojas,
      datasets: [
        {
          labels: dados.lojas,
          pointRadius: "0",
          pointHoverRadius: "0",
          backgroundColor: colorChats.vivida,
          borderWidth: "0",
          data: dados.valores
        }
      ]
    }
  
  } else {
      return (<></>)
  }

  return (
    <Card className='mb-0 mt-4'>
      <CardHeader>
        <Row>
          <Col sm="7">
            <div className="numbers pull-left grafico-valor">{totalGrafico}</div>
          </Col>
          <Col sm="5">
            <div className="pull-right">
              <Badge className={color} pill>
                {title}
              </Badge>
            </div>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>        
        {data.labels && data.labels.length <= 15 && title!== 'Estatística Semanal'
        ?
        <Bar
          data={data}
          options={options}
          width={550}
          height={150}
        />
      :
      <BarrasHorizontal
        title={title}
        color={color}
        dados={dados}
      ></BarrasHorizontal>
      }
      </CardBody>
    </Card>
  )
}

export default BarrasCard








